
import CircularProgress from "@mui/material/CircularProgress";
import React, { useState } from "react";
import propTypes from 'prop-types'
import { RequestStatus } from "../../../logic/api";
import { Dialog, DialogContent } from "@mui/material";


const ProgressDialog: React.FunctionComponent<{
    status?: RequestStatus,
    showOnIdle?: boolean,
    delay?: number,
}> = (props) => {
    const [show, setShow] = useState(false);
    const status = props.status || RequestStatus.idle;
    const delay = props.delay == null ? 1 : (props.delay < 0 ? 0 : props.delay);

    React.useEffect(() => {
        if (status == RequestStatus.loading || (status == RequestStatus.idle && props.showOnIdle == true)) {
            const cancel = setTimeout(function () {
                setShow(true);
            }, delay);
            return () => clearTimeout(cancel);
        } else {
            setShow(false);
        }

    }, [status, props.showOnIdle, props.delay]);

    return <Dialog open={show}>
        <DialogContent>
            <div style={{ marginBottom: 10 }}>
                <CircularProgress></CircularProgress>
            </div>

        </DialogContent>
    </Dialog>
};

ProgressDialog.propTypes = {
    status: propTypes.number,
    delay: propTypes.number,
    showOnIdle: propTypes.bool,
};


export { ProgressDialog };
